import * as React from 'react';
import { Link } from '@chakra-ui/react';
import { Events, VerifactuIssueChecker } from 'core/infrastructure';
import { Res } from 'core/api';
import { NotificationBar } from 'core/ui-next/NotificationBar';

export function VerifactuNotificationBar() {

	const [status, setStatus] = React.useState(VerifactuIssueChecker.getStatus());

	React.useEffect(() => {
		const dispose = Events.on('verifactu:issue-updated', async ({ status }) => setStatus(status));
		return dispose();
	}, [setStatus]);


	const viewerUrl = VerifactuIssueChecker.getVerifactuViewerURL();
	if (!viewerUrl)
		return null;

	return status !== 'OK'
		? <NotificationBar paddingRight={'6'} variant={'success'}>
			<Link variant='underline' href={viewerUrl} target='_blank'>
				{status === 'INVALID_STATUS' ? Res.Web.VERIFACTU_INVALID_STATUS_NOTIFICATION() : Res.Web.VERIFACTU_CANNOT_CHECK_STATUS_NOTIFICATION()}
			</Link>
		</NotificationBar>
		: null;
}
